<i18n src="./coming-soon-i18n.yaml"></i18n>
<template>
    <UtilityPageContainer
        :wIconSrc="require('@/assets/icons/pages/soon.svg')"
        :title="$t('msg-title')"
        :text="$t('msg-text')"
    >
    </UtilityPageContainer>
</template>
<script>
export default {
    name: "ViewUtilitiesComingSoon",
    components: {
        UtilityPageContainer: () =>
            import("@/components/general/utlis/utility-page-container.vue")
    }
};
</script>
